import React from 'react';
import OpacitySelector from "./OpacitySelector.tsx"


const ColorChip: React.FC = ({ baseColor, borderColor, textColor }) => {
  return (
    <div className="colorChip" style={{ 
      backgroundColor: `var(--color-${baseColor})`,
      border: `1px solid var(--color-${borderColor})`,
      color: `var(--color-${textColor})`
    }}>
      <p className="color-name">{baseColor}</p>
      <OpacitySelector baseColor={baseColor}/>
    
    </div>
  );
};

export default ColorChip;